
import { mapState } from "vuex";
import backButtonOutlined from "../components/common/back-button-outlined.vue";
import CommonOrderDialogs from "../components/common/common-order-dialogs.vue";
export default {
  components: { backButtonOutlined, CommonOrderDialogs },
  computed: {
    ...mapState("misc", ["pageTitle"])
  }
};
